export const SITE = {
  name: 'CredInTech',
  domain: 'https://credintech.com',
  email: 'harshit@credintech.com',
  calendly: process.env.GATSBY_CALENDLY_URL || 'https://calendly.com/harshit-rastogi-credinfinite/30min',
  entity: 'CREDINFINITE TECHNOLOGIES PRIVATE LIMITED',
  cin: 'U62011UW2026PTC254010',
  gstin: '09AANCC9028J1Z4',
  nav: ['Services', 'About', 'Contact'],
};
